// Client da API própria do Finance Control (substitui o Supabase).
// Autenticação por JWT guardado no localStorage; 401 derruba a sessão.

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
const TOKEN_KEY = 'fc_token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

let listeners: Array<() => void> = [];

export function onAuthChange(fn: () => void): () => void {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter(l => l !== fn);
  };
}

export function setToken(token: string | null) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
  listeners.forEach(l => l());
}

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

async function request(path: string, options: RequestInit = {}) {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string>),
  };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API_URL}${path}`, { ...options, headers });
  if (res.status === 401 && token) {
    // Sessão expirada: limpa o token para o PrivateRoute redirecionar ao login
    setToken(null);
  }
  if (!res.ok) {
    let mensagem = `Erro ${res.status}`;
    try {
      const body = await res.json();
      if (body?.error) mensagem = body.error;
    } catch {
      // resposta sem corpo JSON
    }
    throw new ApiError(res.status, mensagem);
  }
  return res.json();
}

export const api = {
  get: (path: string) => request(path),
  post: (path: string, body?: unknown) => request(path, { method: 'POST', body: JSON.stringify(body) }),
  put: (path: string, body?: unknown) => request(path, { method: 'PUT', body: JSON.stringify(body) }),
  patch: (path: string, body?: unknown) => request(path, { method: 'PATCH', body: JSON.stringify(body) }),
  delete: (path: string) => request(path, { method: 'DELETE' }),
};
